import {
    ADD_PRICE_PACKAGES_CLIENTS_MODAL,
    AddPricePackagesClientsModal,
    CLOSE_PRICE_PACKAGES_CLIENTS_MODAL,
    DELETE_PRICE_PACKAGES_CLIENTS_MODAL,
    DeletePricePackagesClientsModal,
    PricePackagesClientsModalAction,
    SAVE_PRICE_PACKAGES_CLIENTS_MODAL,
    SavePricePackagesClientsModal,
    SET_PRICE_PACKAGES_CLIENTS_MODAL_DATA,
    SHOW_PRICE_PACKAGES_CLIENTS_MODAL_ERROR,
    ShowPricePackagesClientsModalError
} from '../actions/pricePackagesClientsModal';
import { numericTagValidate } from '../service/InternalGroupHelpers/InternalGroupHelpers';
import {
    isTagIncluded,
    mapTagValueToFirstItem,
    mapTagValueToString
} from '../service/TagCloudTargetingHelper/TagCloudTargetingHelper';
import { PricePackagesClientsModalState } from '../typings/pricePackages';
import { TagState, TargetingTagValue } from '../typings/tagCloudTargeting';

const initialState = {
    isVisible: false,
    isProgress: false,
    title: '',
    tags: []
};

const addPricePackagesClientsModal = (
    state: PricePackagesClientsModalState,
    action: AddPricePackagesClientsModal
): PricePackagesClientsModalState => {
    const { tags } = action;

    return {
        ...state,
        tags: addPriceTags(state.tags, tags),
        errors: []
    };
};
const deletePricePackagesClientsModal = (
    state: PricePackagesClientsModalState,
    action: DeletePricePackagesClientsModal
): PricePackagesClientsModalState => {
    const { tag } = action;

    return {
        ...state,
        tags: deletePriceTags(state.tags, tag),
        errors: []
    };
};

const savePricePackagesClientsModal = (
    state: PricePackagesClientsModalState,
    action: SavePricePackagesClientsModal
): PricePackagesClientsModalState => {
    return {
        ...state,
        isProgress: true,
        errors: []
    };
};
const showPricePackagesClientsModalError = (
    state: PricePackagesClientsModalState,
    action: ShowPricePackagesClientsModalError
): PricePackagesClientsModalState => {
    return {
        ...state,
        isVisible: true,
        isProgress: false,
        errors: action.errors
    };
};

export interface TagMaps {
    included: Record<string, boolean>;
    excluded: Record<string, boolean>;
}

export const addPriceTags = (
    existingTags: TargetingTagValue[],
    addedTags: TargetingTagValue[]
): TargetingTagValue[] => {
    let newExistingTags = existingTags;
    let newAddedTags = addedTags;

    addedTags.forEach((addedTag: TargetingTagValue) => {
        const { type, value } = addedTag;
        const { included } = getTagMap(existingTags);

        // вводимое значение должно быть числом
        if (!numericTagValidate(value)) {
            newAddedTags = [];
            return;
        }

        // значение одновременно не может быть included и excluded
        newExistingTags = newExistingTags.filter(tag => {
            return !(
                tag.type !== type &&
                mapTagValueToFirstItem(value).toLowerCase() === mapTagValueToFirstItem(tag.value).toLowerCase()
            );
        });

        newAddedTags = newAddedTags
            .filter(tag => {
                const isIncluded = isTagIncluded(tag);

                // нельзя добавить в excluded, если значения нет в included
                return included[mapTagValueToFirstItem(tag.value)] ? !isIncluded : isIncluded;
            })
            .map(tag => {
                return { ...tag, tagState: TagState.UNSET, value: mapTagValueToFirstItem(tag.value) };
            });
    });

    return [...newExistingTags, ...newAddedTags];
};
const deletePriceTags = (existingTags: TargetingTagValue[], deletedTag: TargetingTagValue): TargetingTagValue[] => {
    const deletedTagIndex = existingTags.findIndex(it => {
        return mapTagValueToString(it.value) === mapTagValueToFirstItem(deletedTag.value);
    });

    if (deletedTagIndex === -1) {
        return existingTags;
    }

    const newTags = [...existingTags];
    newTags.splice(deletedTagIndex, 1);

    return newTags;
};

export const pricePackagesClientsModalReducer = (
    state: PricePackagesClientsModalState = initialState,
    action: PricePackagesClientsModalAction
): PricePackagesClientsModalState => {
    switch (action.type) {
        case SET_PRICE_PACKAGES_CLIENTS_MODAL_DATA:
            return action.modalData;
        case CLOSE_PRICE_PACKAGES_CLIENTS_MODAL:
            return initialState;
        case ADD_PRICE_PACKAGES_CLIENTS_MODAL:
            return addPricePackagesClientsModal(state, action);
        case DELETE_PRICE_PACKAGES_CLIENTS_MODAL:
            return deletePricePackagesClientsModal(state, action);
        case SAVE_PRICE_PACKAGES_CLIENTS_MODAL:
            return savePricePackagesClientsModal(state, action);
        case SHOW_PRICE_PACKAGES_CLIENTS_MODAL_ERROR:
            return showPricePackagesClientsModalError(state, action);
        default:
            return state;
    }
};

export const getTagMap = (tags: TargetingTagValue[]): TagMaps => {
    return tags.reduce(
        (acc: TagMaps, tag: TargetingTagValue) => {
            const { value, type } = tag;
            return {
                ...acc,
                [type]: {
                    ...acc[type],
                    [mapTagValueToFirstItem(value).toLowerCase()]: true
                }
            };
        },
        {
            included: {},
            excluded: {}
        } as TagMaps
    );
};
